export enum ContributionSchedule {
  WEEKLY = '0 0 * * 1',
  SEMI_MONTHLY = '0 0 1,15 * *',
  MONTHLY = '0 0 1 * *',
}
